// extracted by mini-css-extract-plugin
export default {"Container":"JQuV6M93Z7vH3NFK6c15","Title":"GrvpGScGsx32vwKXIdSg","InfoPanel":"MDJHhahylVv53BE98stQ","Content":"eEXtG3RaETsaauK6kRKz"};